module.exports = __webpack_public_path__ + "img/Jet Wings alt.ca7ebcf4.png";